export default __webpack_public_path__ + "static/24934223-day-a9940cf1fd48083f2aa82daff572abd7.mp4";